import * as React from 'react'
function SvgCurrencyExchange(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28.75 23.5a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5zm-21-3.25c.966 0 1.75.784 1.75 1.75v5.25H13v-1.089a2 2 0 013.25-1.561l3.548 2.838a2 2 0 010 3.124L16.249 33.4A2 2 0 0113 31.84V30.75H8a2 2 0 01-2-2V22c0-.966.784-1.75 1.75-1.75zM25 6.161a2 2 0 012 2V9.25h5a2 2 0 012 2V18a1.75 1.75 0 01-3.5 0v-5.25H27v1.089a2 2 0 01-3.25 1.561l-3.548-2.838a2 2 0 010-3.124L23.751 6.6A2 2 0 0125 6.16zM11.25 6a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyExchange
